import React from 'react'

const Others = () => {
    return (
        <div>
            <div  id = "others" class="others">
                <h1>Others</h1>
                <div class="others__container">
                    <div class="others__card">
                        <h2>Volunteering</h2>
                        <h3>Impart Education</h3>
                        <div class="others__details">
                            <p>Tutor since June 2021</p>
                            <p>Curriculum coordinator since May 2021</p>
                        </div>
                    </div>
                    <div class="others__card">
                        <h2>Hobbies</h2>
                        <h3>Know Me Better!</h3>
                        <div class="others__details">
                            <p>Chess</p>
                            <p>Cycling</p>
                            <p>Investing</p>
                            <p>Travelling</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Others
